<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-lg-12">
        <div class="card h-100">
          <div class="card-header pb-0 p-3">
            <div class="row">
              <div class="col-6 d-flex align-items-center">
                <h6 class="mb-0">إعدادات المصادقة</h6>
              </div>
            </div>
          </div>
          <div class="card-body p-3">

            <div class="mb-5 border-bottom pb-4">
              <h5 class="text-center mt-3">مصادقة جوجل درايف</h5>
              <p class="text-center text-secondary mb-4">انقر على الزر أدناه لربط حساب جوجل درايف واليوتيوب.</p>
              <div class="text-center">
                <button @click="initiateGoogleAuth" class="btn btn-primary" style="background-color: #db4437; border-color: #db4437;">
                  <i class="fab fa-google me-2"></i> المصادقة مع جوجل
                </button>
              </div>
            </div>

            <div class="mb-5 border-bottom pb-4">
              <h5 class="text-center mt-3">مصادقة صفحات فيسبوك</h5>
              <p class="text-center text-secondary mb-4">انقر على الزر أدناه لربط صفحات فيسبوك والبدء في الرفع.</p>
              <div class="text-center">
                <button @click="initiateFacebookAuth" class="btn btn-primary" style="background-color: #3b5998; border-color: #3b5998;">
                  <i class="fab fa-facebook me-2"></i> المصادقة مع فيسبوك
                </button>
              </div>
            </div>

            <div>
              <h5 class="text-center mt-3">مصادقة تيك توك</h5>
              <p class="text-center text-secondary mb-4">انقر على الزر أدناه لربط حساب تيك توك والبدء في الرفع.</p>
              <div class="text-center">
                <button @click="initiateTikTokAuth" class="btn btn-primary" style="background-color: #000000; border-color: #000000;">
                  <i class="fab fa-tiktok me-2"></i> المصادقة مع تيك توك
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/Axios';

export default {
  // تم تغيير الاسم ليعكس الغرض العام للصفحة
  name: "AuthenticationSettings",
  methods: {
    // دالة المصادقة مع جوجل (لم تتغير)
    async initiateGoogleAuth() {
      try {
        const baseUrl = axios.defaults.baseURL.replace('/api', '');
        // يستخدم مسار الـ web.php الجديد: /auth/google/oauth/redirect
        window.location.href = `${baseUrl}/auth/google/oauth/redirect`;
      } catch (error) {
        console.error('Error initiating Google auth:', error);
      }
    },

    // دالة المصادقة مع فيسبوك (الجديدة)
    initiateFacebookAuth() {
      const baseUrl = axios.defaults.baseURL.replace('/api', '');
      const user = JSON.parse(localStorage.getItem('user_free'));
      const token = user ? user.token : null;

      if (token) {
        window.location.href = `${baseUrl}/auth/facebook/oauth/redirect?token=${token}`;
      } else {
        alert('Admin token not found. Please log in again.');
        this.$router.push({ name: 'Login' });
      }
    },

    // دالة المصادقة مع تيك توك (الجديدة)
    initiateTikTokAuth() {
      const baseUrl = axios.defaults.baseURL.replace('/api', '');
      const user = JSON.parse(localStorage.getItem('user_free'));
      const token = user ? user.token : null;

      if (token) {
        window.location.href = `${baseUrl}/auth/tiktok/oauth/redirect?token=${token}`;
      } else {
        alert('Admin token not found. Please log in again.');
        this.$router.push({ name: 'Login' });
      }
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const authStatus = urlParams.get('auth');

    if (authStatus === 'success') {
      alert('تمت المصادقة بنجاح!');
      this.$router.replace({ query: {} }); // يمسح ?auth
    } else if (authStatus === 'error') {
      alert('فشل المصادقة.');
      this.$router.replace({ query: {} });
    }
  },
};
</script>

<style scoped>
/* إضافة الأيقونات إذا لم تكن موجودة بالفعل */
.fa-google {
  color: white;
}
.fa-facebook {
  color: white;
}
.fa-tiktok {
  color: white;
}
/* تنسيقات إضافية لزرار Facebook إذا كان مطلوباً */
</style>
